<app-card #card [cardTitle]="'COMPLETED_REVIEWS.COMPLETED_ASSESSMENTS' | translate"
    [useExternalButtons]="true"
    [showEdit]="false"
    [disabled]="!settingState.reviewPeriod.value">
    <div>
        <div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'COMPLETED_REVIEWS.SEARCH' | translate }}</mat-label>
                <input matInput type="text" [formControl]="searchControl" autocomplete="off">
                <button *ngIf="searchControl.value" matSuffix mat-icon-button [attr.aria-label]="'GENERAL.DELETE' | translate" (click)="clearText()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

            <ng-container *ngIf="items$ | async as items">
                <div class="message-panel">
                    {{ searchMessage }}
                </div>
                <div class="scroll-panel">
                    <app-dynamic-list-item [actionState]="card.actionState" [noActions]="true" *ngFor="let item of items; index as i" [index]="i" [source]="item">
                        <div slot="readonly">
                            <ng-container *ngIf="reviewPeriod && (reviewPeriod.reviewType === reviewTypes.TER)">
                                <a class="secondary flex-horizontal mainitems" [routerLink]="['/reports/panorama-aura', item.itemSource.id, reviewPeriod.id]">
                                    <div class="field-text">
                                        <span class="name"><strong>{{ item.itemSource.name }}</strong></span>
                                        <div class="sub-text inactive-user-label" *ngIf="EmployeeHelper.isEmployeeInactive(item.itemSource)">
                                            {{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}
                                        </div>
                                        <span class="sub-text">({{ item.itemSource.email }}) </span>
                                        <span class="sub-text">{{ item.itemSource.employeeIdentifier ?? '' }}</span>
                                    </div>
                                </a>
                            </ng-container>

                            <ng-container *ngIf="reviewPeriod && reviewPeriod.reviewType === reviewTypes.PersonalityTest">
                                <div class="flex-horizontal">
                                    <div class="field-text">
                                        <div class="name"><strong>{{ item.itemSource.name }}</strong></div>
                                        <div class="sub-text inactive-user-label" *ngIf="EmployeeHelper.isEmployeeInactive(item.itemSource)">
                                            {{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}
                                        </div>
                                        <div class="sub-text">
                                            <span [attr.title]="'COMPLETED_REVIEWS.EMPLOYEE_EMAIL' | translate">{{ item.itemSource.email }} </span>
                                            <span [attr.title]="'COMPLETED_REVIEWS.EMPLOYEE_ID' | translate">{{ item.itemSource.employeeIdentifier ?? '' }}</span>
                                        </div>
                                        <div class="sub-text" [attr.title]="'COMPLETED_REVIEWS.DISTORTION_CLICKING' | translate">
                                            torzítás: <strong>{{ item.itemSource.distortion }}</strong>, kattintgatás: <strong>{{ item.itemSource.clicking }}</strong>
                                        </div>
                                        <div class="sub-text" *ngIf="item.itemSource.closedOn" [attr.title]="'COMPLETED_REVIEWS.COMPLETION_DATE' | translate">
                                            {{ item.itemSource.closedOn | localizedDate }}
                                        </div>
                                    </div>
                                    <div class="field-icons flex-horizontal mainitems">
                                        <a mat-icon-button [attr.title]="'COMPLETED_REVIEWS.INDIVIDUAL_REPORT' | translate" [routerLink]="['/reports/personality-test/details', item.itemSource.reviewPeriodEmployeeId]" *ngIf="item.itemSource.reviewPeriodEmployeeId">
                                            <mat-icon fontSet="material-icons-outlined">article_outline</mat-icon>
                                        </a>
                                        <a mat-icon-button [attr.title]="'COMPLETED_REVIEWS.DIAGRAM_REPORT' | translate" [routerLink]="['/reports/personality-test/diagram', item.itemSource.reviewPeriodEmployeeId]" *ngIf="item.itemSource.reviewPeriodEmployeeId && isSziluettDiagramAllowed">
                                            <mat-icon fontSet="material-icons-outlined">insert_chart_outline</mat-icon>
                                        </a>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="reviewPeriod && (reviewPeriod.reviewType === reviewTypes.MilioStressMap || reviewPeriod.reviewType === reviewTypes.MilioTeamDysfunction)">
                                <div class="flex-horizontal">
                                    <div class="list-col flex-h align-items-center flex-fill">
                                        <div>
                                            <div>{{ item.itemSource.name }}</div>
                                            <div class="sub-text inactive-user-label line-height-1" *ngIf="EmployeeHelper.isEmployeeInactive(item.itemSource)">
                                                {{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list-col flex-h align-items-center">{{ getStatus(item.itemSource.status) }}</div>
                                    <div class="field-icons flex-horizontal mainitems">
                                        <a mat-icon-button [routerLink]="['/reports/team-dysfunctions', item.itemSource.reviewPeriodId]" *ngIf="reviewPeriod.reviewType === reviewTypes.MilioTeamDysfunction">
                                            <mat-icon fontSet="material-icons-outlined" [attr.title]="'COMPLETED_REVIEWS.STATUS_ASSESSMENT' | translate">article_outline</mat-icon>
                                        </a>
                                        <a mat-icon-button [routerLink]="['/reports/team-stressmap', item.itemSource.reviewPeriodId]" *ngIf="reviewPeriod.reviewType === reviewTypes.MilioStressMap">
                                            <mat-icon fontSet="material-icons-outlined" [attr.title]="'COMPLETED_REVIEWS.STATUS_ASSESSMENT' | translate">article_outline</mat-icon>
                                        </a>
                                    </div>
                                </div>
                            </ng-container>

                        </div>
                    </app-dynamic-list-item>
                </div>
                <mat-paginator #paginator [length]="total"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pagingSettingsChanged($event)"
                            [attr.aria-label]="'GENERAL.CHOOSE_PAGE' | translate">
                </mat-paginator>
            </ng-container>
            
        </div>        
    </div>
</app-card>
